import {
  EMOJI_AVATAR_ATTR, PARTICIPANT_FIELDS_ATTR,
} from '@/vuex/modules/presentation/setting.module'
import AccountSettingsApi from '@/api/accountSettings'
import constant from '@/constant'

const defaultSelectedFields = constant.participantSystemFields.map((field) => ({
  id: field.id,
  required: false,
  hidden: false,
}))

const UPDATE_PRESENTATION_ATTRIBUTE_MUTATION = 'presentationAttributeModule/updatePresentationAttribute'
const USER_SETTING_ATTRIBUTES = [EMOJI_AVATAR_ATTR]

const SUBSCRIBED_MUTATIONS = [
  UPDATE_PRESENTATION_ATTRIBUTE_MUTATION,
]

const APPLY_REMEMBER_SETTING_MUTATIONS = [
  'afterCreateNewPresentationAction',
]

// ACTIONS
const UPDATE_PARTICIPANT_FIELDS_ACTION = 'presentationSetting/updateParticipantFields'
const APPLIED_REMEMBER_SETTING_ACTIONS = [
  UPDATE_PARTICIPANT_FIELDS_ACTION,
]

const presentationAttributeMutationHandler = (store, mutation, state) => {
  const { attributeName, attributeValue } = mutation.payload
  if (!USER_SETTING_ATTRIBUTES.includes(attributeName)) return
  store.dispatch('updateUserRememberSettingAction', {
    ...state.currentUser?.rememberSettings,
    [attributeName]: attributeValue,
  })
}

const handlers = {
  [UPDATE_PRESENTATION_ATTRIBUTE_MUTATION]: presentationAttributeMutationHandler,
}

const actionHandlers = {
  [UPDATE_PARTICIPANT_FIELDS_ACTION]: (store, action) => {
    const { participantFields } = action.payload

    store.dispatch('updateUserRememberSettingAction', {
      ...(store?.state?.currentUser?.rememberSettings || {}),
      [PARTICIPANT_FIELDS_ATTR]: participantFields,
    })
  },
}

const rememberSettingPlugin = (store) => {
  // Remember Setting Scenario
  store.subscribe((mutation, state) => {
    if (!SUBSCRIBED_MUTATIONS.includes(mutation.type)) return
    handlers[mutation.type](store, mutation, state)
  })

  store.subscribeAction((action) => {
    if (!APPLIED_REMEMBER_SETTING_ACTIONS.includes(action.type)) return
    actionHandlers[action.type](store, action)
  })
  // -----------------------------------------------------------------------------

  // Apply Remembered Setting Scenario
  store.subscribeAction({
    after: (action) => {
      if (!APPLY_REMEMBER_SETTING_MUTATIONS.includes(action.type)) return
      const presentation = action.payload
      // Emoji avatar
      store.dispatch('presentationSetting/updateShowEmojiAvatarSetting', {
        presentationId: presentation.id,
        value: store.state.currentUser.rememberSettings?.[EMOJI_AVATAR_ATTR],
      })

      // Participant Fields — skip if team admin has locked audience admission settings
      const applyParticipantFieldDefaults = async () => {
        const { accountId } = store.state.currentUser || {}
        if (accountId) {
          try {
            const settings = await AccountSettingsApi.getAccountSettings()
            if (settings.allowOverrideAudienceAdmission === false) return
          } catch {
            // If fetch fails, proceed with remember settings
          }
        }

        store.dispatch('presentationSetting/updateParticipantFields', {
          presentationId: presentation.id,
          participantFields: store.state.currentUser.rememberSettings?.[PARTICIPANT_FIELDS_ATTR],
        })

        store.dispatch('presentationSetting/updateSelectedParticipantFields', {
          presentationId: presentation.id,
          fields: defaultSelectedFields,
        })
      }
      applyParticipantFieldDefaults()
    },
  })
}

export default rememberSettingPlugin
